// extracted by mini-css-extract-plugin
export default {"brand":"BrandInsights_brand__WCg7w","brand_specs":"BrandInsights_brand_specs__9u1u7","partition":"BrandInsights_partition__NH6x3"};